/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDrsMan401k.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/drs-man-401k";

export class AutogenModelDrsMan401k<RowType extends ModelRow> extends Endpoint<RowType, RowDrsMan401kFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDrsMan401k extends ModelRow<RowDrsMan401kFields> {
	constructor(values?: Partial<RowDrsMan401kFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDrsMan401kFields {
	company_id: string;
	contrib_type: string;
	contribution: number;
	contribution_c: string;
	contribution_d: Date;
	contribution_n: number;
	contribution_r: number;
	deduct_code_id: string;
	fund_id: string;
	id: string;
	matching_amount: number;
	matching_amount_c: string;
	matching_amount_d: Date;
	matching_amount_n: number;
	matching_amount_r: number;
	settlement_id: string;
}

